module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/uy-091841c8018480091faefbc9124eb3eb.svg";